import './recommon-list.less';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ListItem from 'components/app-detail/list-item/list-item';

class RecommonList extends Component {
  static propTypes = {
    recommonList: PropTypes.array,
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { recommonList } = this.props;
    return (
      <div className="recommon-container">
        <div className="header">
          <strong className="header-title">你可能感兴趣的</strong>
          <a className="viewmore" href="/preview/" target="_blank">
            查看更多&gt;
          </a>
        </div>
        <ul className="recommon-list">
          {recommonList.map((v, i) => (
            <ListItem key={i} {...v} />
          ))}
        </ul>
      </div>
    );
  }
}

export default RecommonList;
